import getEnvVariable from '@/utils/getEnvVariable';
import HttpAdapter from '@/api/adapters/HttpAdapter';
import DataProvider from '@/api/DataProvider';
import httpClient from '@/api/httpClient';
import { isUndefined, omitBy } from 'lodash';
import store from '@/store';
import resources from './resources';

const overwritedApiUrl = () => {
    if (['QA', 'DEV'].includes(getEnvVariable('VUE_APP_ENV_NAME'))) {
        console.group('IoT Application');
        console.log('%cTo change IoT URL, run:', 'font-weight: bold;');
        console.log(`localStorage.setItem('VUE_APP_IOT_API_URL', '${getEnvVariable('VUE_APP_IOT_API_URL')}')`);
        console.log('%cTo remove IoT overwrite, run:', 'font-weight: bold;');
        console.log(`localStorage.removeItem('VUE_APP_IOT_API_URL')`);
        console.groupEnd();

        return localStorage.getItem('VUE_APP_IOT_API_URL');
    }

    return null;
};

const baseURL = overwritedApiUrl() || getEnvVariable('VUE_APP_IOT_API_URL');

const beforeRequestInterceptor = ({ requestConfig }) => {
    return {
        ...requestConfig,
        responseType: requestConfig.params.responseType,
        headers: omitBy(
            {
                'X-Quext-Customer-Id': store.getters['auth/customerId'],
                'X-Quext-Community-Id': store.getters['auth/community']?.id,
                ...requestConfig.headers,
                'X-App-Id': 'spa-app',
            },
            isUndefined
        ),
    };
};

const afterRequestInterceptor = (data = {}) => {
    const {
        action,
        response: { headers, data: responseData },
    } = data;
    if (action === 'getList') {
        const totalSize = headers['x-total-count'];
        return {
            totalSize: totalSize,
            items: responseData,
        };
    }
    return responseData;
};

const httpAdapter = new HttpAdapter(httpClient(baseURL), resources, beforeRequestInterceptor, afterRequestInterceptor);

export default new DataProvider({
    handle: (action, resource, params) => {
        return httpAdapter.handle(action, resource, params);
    },
});
